
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button'
import image1 from '../images/galeries/image1.jpg'
import image2 from '../images/galeries/image2.jpg'
import image3 from '../images/galeries/image3.jpg'
import image4 from '../images/galeries/image4.jpg'
import image5 from '../images/galeries/image5.jpg'
import image6 from '../images/galeries/image6.jpg'
import image7 from '../images/galeries/image7.jpg'
import image8 from '../images/galeries/image8.jpg'
import Presentation from '../images/galeries/Presentation.pptx'

import '../fichierCss/Affichage.css'

interface GaleryProps {
  image?: string;
  titre?: string;
  contenu?: string;
}

const Galery = ({ image, titre, contenu }: GaleryProps) => {
   
    return (
      <section className="gallery-block cards-gallery"> 
	    <div className="container">	       
	        <div className="row">
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image1.jpg">
	                		<img src={image1} alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
						<a className="lightbox" href="../img/image2.jpg">
		                	<img src={image2}  alt="Card Image" className="card-img-top"/>
		                </a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image3.jpg">
	                		<img src={image3}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image4.jpg">
	                		<img src={image4}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit </p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image5.jpg">
	                		<img src={image5}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image6.jpg">
	                		<img src={image6}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	        </div>
          <div className="row">
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image1.jpg">
	                		<img src={image1} alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
						<a className="lightbox" href="../img/image2.jpg">
		                	<img src={image2}  alt="Card Image" className="card-img-top"/>
		                </a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image3.jpg">
	                		<img src={image3}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image4.jpg">
	                		<img src={image4}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit </p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image5.jpg">
	                		<img src={image5}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image6.jpg">
	                		<img src={image6}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	        </div>
          <div className="row">
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image1.jpg">
	                		<img src={image1} alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
						<a className="lightbox" href="../img/image2.jpg">
		                	<img src={image2}  alt="Card Image" className="card-img-top"/>
		                </a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image3.jpg">
	                		<img src={image3}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image4.jpg">
	                		<img src={image4}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit </p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image5.jpg">
	                		<img src={image5}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image6.jpg">
	                		<img src={image6}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	        </div>
          <div className="row">
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image1.jpg">
	                		<img src={image1} alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
						<a className="lightbox" href="../img/image2.jpg">
		                	<img src={image2}  alt="Card Image" className="card-img-top"/>
		                </a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image3.jpg">
	                		<img src={image3}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image4.jpg">
	                		<img src={image4}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit </p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image5.jpg">
	                		<img src={image5}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image6.jpg">
	                		<img src={image6}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	        </div>
          <div className="row">
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image1.jpg">
	                		<img src={image1} alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
						<a className="lightbox" href="../img/image2.jpg">
		                	<img src={image2}  alt="Card Image" className="card-img-top"/>
		                </a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image3.jpg">
	                		<img src={image3}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image4.jpg">
	                		<img src={image4}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit </p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image5.jpg">
	                		<img src={image5}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image6.jpg">
	                		<img src={image6}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	        </div>
          <div className="row">
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image1.jpg">
	                		<img src={image1} alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
						<a className="lightbox" href="../img/image2.jpg">
		                	<img src={image2}  alt="Card Image" className="card-img-top"/>
		                </a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image3.jpg">
	                		<img src={image3}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor .</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image4.jpg">
	                		<img src={image4}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit </p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	            <div className="col-md-3 col-lg-2">
	                <div className="card border-0 transform-on-hover">
	                	<a className="lightbox" href="../img/image5.jpg">
	                		<img src={image5}  alt="Card Image" className="card-img-top"/>
	                	</a>
	                    <div className="card-body">
	                        <h6><a href="#">Lorem Ipsum</a></h6>
	                        <p className="text-muted card-text">Lorem ipsum dolor sit.</p>
							<Button variant="primary" size='sm' active>
    									Lire
  							</Button>
	                    </div>
	                </div>
	            </div>
	           
	        </div>
	    </div>
    </section>
      );
} 
export default Galery